import React, { useEffect } from "react"; // eslint-disable-line
import { useDispatch, useSelector } from "react-redux";

import { observeDoc } from "api";
// import { useParams } from "reducers/hooks";
import { getBusiness } from "reducers/businessReducer";
import { useParams } from "react-router-dom";

import {
  addBusinessError,
  addBusinessLoading,
  addBusinessSuccess,
} from "actions/business";

export default function useBusiness() {
  const params = useParams(["id"]);
  const businessUid = params.id;
  const dispatch = useDispatch();
  const { error, loading, business } = useSelector(getBusiness);

  useEffect(() => {
    dispatch(addBusinessLoading());
    return observeDoc(`businesses/${businessUid}`, (business) => {
      if (!business) {
        dispatch(addBusinessError());
      } else {
        dispatch(addBusinessSuccess(business));
      }
    });
  }, [businessUid, dispatch]);

  return {
    error,
    loading,
    business,
  };
}
